import { 
	HIDE_ALERT, 
	SET_MESSAGE, 
	SET_LIGHT_FOOTER, 
	SET_POPUP, 
	HIDE_POPUP,
	SET_SUBSCRIPTION_POP_UP,
	SET_LOAD_SPINNER
} from '../types';

const initialStore = {
	showAlert: {
		type: null,
		message: null,
	},
	isLightFooter: false,
	popup: {
		imgId: '',
		active: false
	},
	subscriptionPopup: false,
	isLoadSpinner : false
};

const uiReducer = (state = initialStore, action) => {
	switch(action.type) {	
		case SET_MESSAGE: {
			return {...state, showAlert: {...action.payload} }
		}	
		case HIDE_ALERT: {
			return {...state, showAlert: { type: null, message: null } }
		}
		case SET_LIGHT_FOOTER: {
			return {...state, isLightFooter: action.payload }
		}
		case SET_POPUP: {
			return {...state, popup: {...action.payload} }
		}
		case HIDE_POPUP: {
			return {...state, popup: { imgId: '', active: false } }
		}
		case SET_SUBSCRIPTION_POP_UP: {
			return {...state, subscriptionPopup: action.payload }
		}
		case SET_LOAD_SPINNER: {
			return {...state, isLoadSpinner: action.payload }
		}
		default : return state;
	};
};

export default uiReducer;
